import React, { useState } from "react";
import { FaArrowLeftLong } from "react-icons/fa6";
import InfoCards from "../../shared/infoCards/InfoCards";
import { createTable } from "../../../services/createTable";
import dayjs from "dayjs";
import LocationInput from "./LocationInput";
import { Link, useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import CustomCalendar from "./CustomCalendar";
import Description from "./Description";

const steps = [
  "Table Name",
  "Description",
  "Inclusions",
  "Table Date",
  "Theme",
  "Price and Seats", // New step
];

const genres = [
  "Beginners",
  "Experts",
  "Regional",
  "Business",
  "Corporate",
  "Celebrity",
  "Festival",
  "Student",
  "Active",
];

const Stepper = () => {
  const navigate = useNavigate();

  const [step, setStep] = useState(0);
  const [formData, setFormData] = useState({
    tableName: "",
    description: "",
    pricePerSeat: "",
    numberOfSeats: "",
    inclusions: "",
    exclusions: "No additional orders",
    tableDate: "",
    startsAt: "",
    theme: 31,
    genreTags: "",
  });
  const [location, setLocation] = useState(null);

  const interestCodes = {
    travel: 30,
    other: 31,
    relationships: 33,
    taboo: 34,
    fAndB: 35,
    inTheShoesOf: 36,
    Books: 10,
  };
  const toggleGenre = (genre) => {
    setFormData((prev) => ({
      ...prev,
      genreTags: prev.genreTags.includes(genre)
        ? prev.genreTags.filter((g) => g !== genre)
        : [...prev.genreTags, genre],
    }));
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
  };

  const validateStep = () => {
    switch (step) {
      // case 1:
      //   if (!location) {
      //     toast.error("Please select a location.");
      //     return false;
      //   }
      //   break;
      case 0:
        if (!formData.tableName.trim()) {
          toast.error("Table Name is required.");
          return false;
        }
        break;
      case 2:
        if (!formData.description.trim()) {
          toast.error("Description is required.");
          return false;
        }
        break;
      case 3:
        if (!formData.inclusions.trim()) {
          toast.error("Please specify what is included.");
          return false;
        }
        if (!formData.exclusions.trim()) {
          toast.error("Please specify what is excluded.");
          return false;
        }
        break;
      case 4:
        if (!formData.tableDate) {
          toast.error("Please select a table date.");
          return false;
        }
        if (!formData.startsAt) {
          toast.error("Please select a start time.");
          return false;
        }
        break;
      // case 5:
      //   if (!formData.genreTags) {
      //     toast.error("Please select Price.");
      //     return false;
      //   }
      //   break;
      case 5:
        if (!formData.pricePerSeat) {
          toast.error("Please select Price.");
          return false;
        }
        if (formData.pricePerSeat > 2000) {
          toast.error("Price per seat should be between 100 and 2000");
          return false;
        }
        if (formData.pricePerSeat < 100) {
          toast.error("Price per seat should be between 100 and 2000");
          return false;
        }

        if (!formData.numberOfSeats) {
          toast.error("Please select seat numbers.");
          return false;
        }
        break;
      default:
        return true;
    }
    return true;
  };
  const nextStep = () => {
    if (validateStep()) {
      setStep((prev) => Math.min(prev + 1, steps.length));
    }
  };

  const prevStep = () => setStep((prev) => Math.max(prev - 1, 0));
  const handleSubmit = async () => {
    if (!formData.pricePerSeat) {
      toast.error("Please select Price.");
      return false;
    }
    if (formData.pricePerSeat < 100) {
      toast.error("Price per seat should be minimum 100");
      return false;
    }
    if (formData.pricePerSeat > 2000) {
      toast.error("Price per seat should be maximum 2000");
      return false;
    }
    if (!formData.numberOfSeats) {
      toast.error("Please select seat numbers.");
      return false;
    }
    const formattedDate = dayjs(formData?.tableDate).format("DD-MM-YYYY");
    const formattedTime = formData?.startsAt; // Assuming startsAt is already in HH:mm format

    const event_date = `${formData?.tableDate} ${formattedTime}`;

    const payload = {
      type: 2,
      min_seats: formData?.numberOfSeats,
      max_seats: formData?.numberOfSeats,
      price: formData?.pricePerSeat,
      created_for: Number(localStorage.getItem("@userAccount")),
      description: formData?.description,
      category: Number(formData?.theme),
      tags: formData?.genreTags,
      table_expense: 1,
      event_date: event_date,
      title: formData?.tableName,
      inclusion: formData?.inclusions,
      exclusions: formData?.exclusions,
      location: { lat: location?.lat, lng: location?.lng },
      address: location?.address,
    };
    console.log("======>form", payload);
    try {
      const response = await createTable(payload);
      console.log("=======>response", response.details?.id);
      navigate(`/table-banner/${response.details?.id}`);
    } catch (error) {}
  };

  return (
    <div className="w-full mx-auto pt-10 md:px-20 bg-white ">
      {/* Stepper UI */}
      <div className="w-full bg-gray-300 rounded-full h-2.5 mb-6">
        <div
          className="bg-[#e2b760] h-2.5 rounded-full transition-all duration-300"
          style={{ width: `${(step / steps.length) * 100}%` }}
        ></div>
      </div>

      {/* Navigation Buttons */}
      <div className="mt-3 flex justify-between">
        {step > 0 ? (
          <button
            onClick={prevStep}
            className="px-4 py-2 font-semibold mb-3 text-black gap-2 flex items-center justify-between"
          >
            <FaArrowLeftLong /> Back
          </button>
        ) : (
          <Link
            to="/"
            className="px-4 py-2 font-semibold gap-2 mb-3 text-black flex items-center justify-between"
          >
            <FaArrowLeftLong /> Back
          </Link>
        )}
      </div>
      <div className="flex gap-5 items-start justify-start pl-5 md:pl-0 md:justify-center ">
        <div className="md:w-[45rem] md:px-5 ">
          {/* Step Forms */}
          {step === 1 && (
            <LocationInput location={location} setLocation={setLocation} />
          )}
          {step === 0 && (
            <div>
              <label className="block mb-2 font-semibold text-black text-xl md:text-3xl ">
                Table Name
              </label>
              <input
                type="text"
                name="tableName"
                placeholder="What do you want to call your table?"
                value={formData.tableName}
                onChange={handleChange}
                className="w-[18.5rem] md:w-full p-2 border rounded-xl mt-2 h-12 text-black"
              />
            </div>
          )}

          {step === 2 && (
            <Description formData={formData} handleChange={handleChange} />
          )}

          {step === 3 && (
            <div>
              <label className="block mb-2 font-semibold text-black text-xl md:text-3xl ">
                Inclusions
              </label>

              <input
                type="text"
                name="inclusions"
                placeholder="What's included in the pricing you've set for your guests?"
                value={formData.inclusions}
                onChange={handleChange}
                className="w-[18.5rem] md:w-full p-2 border rounded-xl mt-2 h-12 text-black"
              />

              <label className="block mt-4 mb-2 font-semibold text-black text-xl md:text-3xl ">
                Exclusions
              </label>
              <input
                type="text"
                name="exclusions"
                placeholder="What do you want to add in the table?"
                value={formData.exclusions}
                onChange={handleChange}
                className="w-[18.5rem] md:w-full p-2 border rounded-xl mt-2 h-12 text-black"
              />
            </div>
          )}

          {step === 4 && (
            <div>
              <label className="block mb-2 font-semibold text-black text-xl md:text-3xl ">
                Table Date
              </label>
              {/* <input
                type="date"
                name="tableDate"
                value={formData.tableDate}
                onChange={handleChange}
                className="w-[18.5rem] md:w-full p-2 border rounded-xl mt-2 h-12 text-black"
              /> */}
              <CustomCalendar formData={formData} setFormData={setFormData} />

              <label className="block mt-4 mb-2 font-semibold text-black text-xl md:text-3xl ">
                Start Time
              </label>
              <input
                type="time"
                name="startsAt"
                value={formData.startsAt}
                onChange={handleChange}
                className="w-[18.5rem] md:w-full p-2 border rounded-xl mt-2 h-12 text-black"
              />
            </div>
          )}

          {/* {step === 5 && (
            <div>
              <label className="block mb-2 font-semibold text-black text-xl md:text-3xl ">
                Choose the theme of the table
              </label>

              <select
                name="theme"
                value={formData.theme}
                onChange={handleChange}
                className="w-full p-2 border rounded-xl mt-1 h-12 text-black"
              >
                <option value="">Select a theme</option>
                <option value={interestCodes.travel}>Travel</option>
                <option value={interestCodes.other}>Other</option>
                <option value={interestCodes.relationships}>
                  Relationships
                </option>
                <option value={interestCodes.taboo}>Taboo</option>
                <option value={interestCodes.fAndB}>Food & Beverage</option>
                <option value={interestCodes.inTheShoesOf}>
                  In The Shoes Of
                </option>
                <option value={interestCodes.Books}>Books</option>
              </select>

              <div>
                <label className="block mt-4 mb-2 font-semibold text-black text-xl md:text-3xl ">
                  Choose Genres
                </label>

                <div className="flex flex-wrap gap-2 pt-2 rounded-xl">
                  {genres.map((genre) => (
                    <button
                      key={genre}
                      onClick={() =>
                        setFormData((prev) => ({ ...prev, genreTags: genre }))
                      } // Single selection
                      className={`px-4 py-2 rounded-full transition-all duration-300 text-sm font-medium ${
                        formData.genreTags === genre
                          ? "bg-[#e2b760] text-white"
                          : "bg-gray-200 text-gray-700"
                      }`}
                    >
                      {genre}
                    </button>
                  ))}
                </div>
              </div>
            </div>
          )} */}
          {step === 5 && (
            <div>
              <label className="block mb-2 font-semibold text-black text-xl md:text-3xl ">
                Price and Seats
              </label>
              <label className="block mb-2 font-base text-gray-600 text-sm">
                Price per seat
              </label>
              <input
                type="number"
                name="pricePerSeat"
                placeholder="Enter price per seat"
                value={formData.pricePerSeat}
                onChange={handleChange}
                className="w-[18.5rem] md:w-full p-2 border rounded-xl mt-1 h-12 text-black"
              />
              <label className="block mt-4 font-base text-gray-700 text-sm ">
                Number of seats
              </label>
              <div className="flex-wrap flex gap-2 mt-2">
                {Array.from({ length: 7 }, (_, i) => i + 4).map((num) => (
                  <div
                    key={num}
                    onClick={() =>
                      setFormData((prev) => ({ ...prev, numberOfSeats: num }))
                    }
                    className={`px-6 py-2  rounded-xl z-[10]  border cursor-pointer ${
                      formData.numberOfSeats === num
                        ? "bg-black text-white border-transparent" // Selected state
                        : "border-gray-600 hover:bg-gray-200 text-black" // Unselected state
                    }`}
                  >
                    {num}
                  </div>
                ))}
              </div>
            </div>
          )}
          <div className="mt-8">
            {step < steps.length ? (
              <button
                onClick={nextStep}
                className="px-4 py-2 w-56 bg-[#e2b760] text-base text-white rounded-xl"
              >
                Next
              </button>
            ) : (
              <button
                onClick={handleSubmit}
                className="px-4 py-2 w-56 bg-[#e2b760] text-base text-white rounded-xl"
              >
                Get the table approved
              </button>
            )}
          </div>
        </div>
        <InfoCards />
      </div>
    </div>
  );
};

export default Stepper;
